export default function(
  state = {
    documentSettings: {},
    searchHistorySettings: {},
    discussionSettings: {},
    discussionEntrySettings: {},
    knowledgeItemSettings: {},
    messages: [],
    applicationProperties: [],
    licence: {},
  },
  action
) {
  switch (action.type) {
    case "SET_LICENCE":
      return Object.assign({}, state, { licence: action.licence });
    case "SET_APPLICATION_PROPERTIES":
      return Object.assign({}, state, {
        applicationProperties: action.properties,
      });
    case "SET_MESSAGES":
      return Object.assign({}, state, { messages: action.messages });
    case "ADD_MESSAGE":
      return Object.assign({}, state, {
        messages: [...state.messages, action.message],
      });
    case "UPDATE_MESSAGE":
      return Object.assign({}, state, {
        messages: state.messages.map(
          (el) =>
            el.id === action.message.id ? Object.assign(el, action.message) : el
        ),
      });
    case "ADD_MESSAGES":
      return Object.assign({}, state, {
        messages: [...state.messages, action.message],
      });
    case "SET_SETTINGS":
      var documentSettings = { ...state.documentSettings };
      var searchHistorySettings = { ...state.searchHistorySettings };
      var reworkSettings = { ...state.reworkSettings };
      var discussionSettings = { ...state.discussionSettings };
      var discussionEntrySettings = { ...state.discussionEntrySettings };
      var knowledgeItemSettings = { ...state.knowledgeItemSettings };
      for (var i = 0; i < action.settings.length; i++) {
        if (action.settings[i].keyName.includes("upref.entry")) {
          if (action.settings[i].keyName.includes("fullscreen")) {
            discussionEntrySettings.fullscreen = action.settings[i];
          } else if (action.settings[i].keyName.includes("extended")) {
            discussionEntrySettings.extended = action.settings[i];
          } else if (action.settings[i].keyName.includes("list")) {
            discussionEntrySettings.list = action.settings[i];
          }
        } else if (action.settings[i].keyName.includes("upref.discussion")) {
          if (action.settings[i].keyName.includes("fullscreen")) {
            discussionSettings.fullscreen = action.settings[i];
          } else if (action.settings[i].keyName.includes("extended")) {
            discussionSettings.extended = action.settings[i];
          } else if (action.settings[i].keyName.includes("list")) {
            discussionSettings.list = action.settings[i];
          }
        } else if (action.settings[i].keyName.includes("upref.searchhistory")) {
          if (action.settings[i].keyName.includes("fullscreen")) {
            searchHistorySettings.fullscreen = action.settings[i];
          } else if (action.settings[i].keyName.includes("extended")) {
            searchHistorySettings.extended = action.settings[i];
          } else if (action.settings[i].keyName.includes("list")) {
            searchHistorySettings.list = action.settings[i];
          }
        } else if (action.settings[i].keyName.includes("upref.reworks")) {
          if (action.settings[i].keyName.includes("fullscreen")) {
            reworkSettings.fullscreen = action.settings[i];
          } else if (action.settings[i].keyName.includes("extended")) {
            reworkSettings.extended = action.settings[i];
          } else if (action.settings[i].keyName.includes("list")) {
            reworkSettings.list = action.settings[i];
          }
        } else if (action.settings[i].keyName.includes("upref.document")) {
          if (action.settings[i].keyName.includes("fullscreen")) {
            documentSettings.fullscreen = action.settings[i];
          } else if (action.settings[i].keyName.includes("extended")) {
            documentSettings.extended = action.settings[i];
          } else if (action.settings[i].keyName.includes("list")) {
            documentSettings.list = action.settings[i];
          }
        } else if (action.settings[i].keyName.includes("upref.knowledgeitem")) {
          if (action.settings[i].keyName.includes("fullscreen")) {
            knowledgeItemSettings.fullscreen = action.settings[i];
          } else if (action.settings[i].keyName.includes("extended")) {
            knowledgeItemSettings.extended = action.settings[i];
          } else if (action.settings[i].keyName.includes("list")) {
            knowledgeItemSettings.list = action.settings[i];
          }
        }
      }
      return Object.assign({}, state, {
        documentSettings: documentSettings,
        searchHistorySettings: searchHistorySettings,
        reworkSettings: reworkSettings,
        discussionSettings: discussionSettings,
        discussionEntrySettings: discussionEntrySettings,
        knowledgeItemSettings: knowledgeItemSettings,
      });
    case "SET_API_LOCATION":
      return Object.assign({}, state, { apiLocation: action.location });
    default:
      return state;
  }
}
